import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import { _HttpClient } from '@delon/theme';
import { finalize, Subscription, zip } from 'rxjs';

import { FinancialAdvisorService } from './financial-advisor.service';
import { QUINNY_AI_AVATAR_URL } from '@core';

@Component({
  selector: 'financial-advisor-header',
  templateUrl: './financial-advisor.component.html',
  styleUrls: ['./financial-advisor.component.less'],
  standalone: false
})
export class HeaderFinancialAdvisorComponent implements OnInit, OnDestroy {
  readonly quinnyAiAvatarUrl = QUINNY_AI_AVATAR_URL;

  loading = false;
  npmAdvice: string = '';
  gpmAdvice: string = '';
  npmInterpretation: string = '';
  gpmInterpretation: string = '';
  isVisible = false;
  isAdvice = false;
  isInterpretation = false;

  npm: any = {};
  gpm: any = {};
  data: any = {};

  private listener!: Subscription;

  constructor(
    public http: _HttpClient,
    private cdr: ChangeDetectorRef,
    private financialAdvisorSrv: FinancialAdvisorService
  ) {
    this.loadContent();
  }

  ngOnInit(): void {
    this.listener = this.financialAdvisorSrv.$triggerEvent.subscribe(() => {
      this.toggleAdvisor();
    });
  }

  ngOnDestroy(): void {
    this.listener.unsubscribe();
  }

  loadContent() {
    this.loading = true;
    this.http
      .get('api/FinancialAdvisor/GetFinancialRatio')
      .pipe(
        finalize(() => {
          this.loading = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe({
        next: result => {
          if (result.npmAdvice) {
            this.npm = {
              advice: this.process(result.npmAdvice.answer),
              interpret: this.process(result.npmInterpretation.answer)
            };
          }

          if (result.gpmAdvice) {
            this.gpm = {
              advice: this.process(result.gpmAdvice.answer),
              interpret: this.process(result.gpmInterpretation.answer)
            };
          }

          this.data = result;
          this.cdr.detectChanges();
        },
        error: () => (this.loading = false)
      });
  }

  process(text: string) {
    return text
      .replaceAll('. **', '. <b>')
      .replaceAll('* **', '&#8226 <b>')
      .replaceAll('**', '</b><br>')
      .replaceAll('\n\n', '<br><br>')
      .replaceAll('\n', '<br><br>');
  }

  toggleAdvisor() {
    this.loading = false;
    this.isVisible = true;

    this.isInterpretation = true;
    if (Object.keys(this.data).length === 0) this.loadContent();
  }

  showContent() {
    if (this.isAdvice == false) {
      this.isAdvice = true;
      this.isInterpretation = false;
    } else {
      this.isAdvice = false;
      this.isInterpretation = true;
    }
    this.cdr.detectChanges();
  }

  handleOk(): void {
    this.isVisible = false;
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  colour(value: boolean): string {
    return value ? 'positive' : 'negative';
  }
}
